<template>
  <div class="header">
    <div class="title">MINECRAFT СНГ</div>

    <Button label="Вики" link="https://wiki.minecis.net/main">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 3V11L14 8L17 11V3"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Button>
  </div>
</template>

<style lang="scss">
.header {
  display: flex;

  margin-left: auto;
  margin-right: auto;

  height: 78px;

  align-items: center;

  box-sizing: border-box;
  justify-content: space-between;

  max-width: 1601px;

  .title {
    color: white;
    font-family: "Unbounded";
    font-weight: 500;
    font-size: 24px;
  }
}
</style>

<script>
import Button from "./Button.vue";

export default {
  name: "Header",
  components: { Button },
};
</script>
